<template>
  <div class="empty-state" :class="[`empty-state--${size}`]">
    <div class="empty-state__inner">
      <div v-if="icon" class="empty-state__icon">
        <BaseIcon :name="icon" :size="iconSize" />
      </div>
      <h3 class="empty-state__title">{{ title }}</h3>
      <p class="empty-state__description">{{ description }}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import { defineComponent, computed } from 'vue';
  import BaseIcon from '@shared/components/BaseIcon.vue';

  export default defineComponent({
    name: 'EmptyState',
    components: {
      BaseIcon,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
      },
      size: {
        type: String,
        default: 'md',
        validator: (value) => ['sm', 'md'].includes(value),
      },
    },
    setup(props) {
      const iconSize = computed(() => (props.size === 'sm' ? '24' : '48'));
      return { iconSize };
    },
  });
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/base/mixins';
  .empty-state {
    &__inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 1rem;
      padding: 2rem;
      border: 2px dashed var(--slate-300);
      border-radius: 0.5rem;
      background-color: var(--slate-50);
      color: var(--slate-500);
    }
    &__icon {
      color: var(--slate-400);
      width: 96px;
      height: 96px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--slate-200);
    }

    &__title {
      margin: 0.5rem 0 0.25rem 0;
      font-weight: 500;
      color: var(--slate-600);
    }

    &__description {
      @include fontSize('md');
      color: var(--slate-500);
      max-width: 24rem;
      margin: 0 auto;
    }

    &--sm {
      .empty-state__inner {
        gap: 0.5rem;
        padding: 1.25rem;
        border-width: 1px;
      }

      .empty-state__icon {
        width: 48px;
        height: 48px;
      }

      .empty-state__title {
        margin: 0;
        font-size: 0.875rem;
      }

      .empty-state__description {
        font-size: 0.8125rem;
      }
    }
  }
</style>
